import { memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { implementAdminCustomExpressions, implementCustomAdminInvariants } from '../../__generated/admin-implementation.js';
import { AnchorPointPosition } from '../../__generated/admin-model/index.js';
import { BoltHole, CamlockHole, CornerBoltHoles, CornerCountersinkHoles, CountersinkHole, DeadboltHole, EuroCylinderHoleAu, EuroCylinderHoleEu, Hole54, KickPlate, KickPlateBoltHoles, KickPlateCountersinkHoles, OvalCylinderHole, PD7Hole, PN6Hole, PlainCylinderHole, PlainLocksetHole, RectangularHole, RectangularPlate, RimCylinderHole, RoundPlate, SquareHole, SquarePlate } from '../../__generated/model/index.js';
import { holeLabels } from '../../implementation/hole.js';
export const plateTypeOptions = [
    {
        value: SquarePlate.type,
        label: 'Square Plate'
    },
    {
        value: RectangularPlate.type,
        label: 'Rectangular Plate'
    },
    {
        value: RoundPlate.type,
        label: 'Round Plate'
    },
    {
        value: KickPlate.type,
        label: 'Kick Plate'
    }
];
export const kickPlateFeatureTypeOptions = [
    {
        value: KickPlateBoltHoles.type,
        label: holeLabels[KickPlateBoltHoles.type]
    },
    {
        value: KickPlateCountersinkHoles.type,
        label: holeLabels[KickPlateCountersinkHoles.type]
    }
];
export const otherFeatureTypeOptions = [
    {
        value: BoltHole.type,
        label: holeLabels[BoltHole.type]
    },
    {
        value: CamlockHole.type,
        label: holeLabels[CamlockHole.type]
    },
    {
        value: CornerBoltHoles.type,
        label: holeLabels[CornerBoltHoles.type]
    },
    {
        value: CornerCountersinkHoles.type,
        label: holeLabels[CornerCountersinkHoles.type]
    },
    {
        value: CountersinkHole.type,
        label: holeLabels[CountersinkHole.type]
    },
    {
        value: DeadboltHole.type,
        label: holeLabels[DeadboltHole.type]
    },
    {
        value: EuroCylinderHoleEu.type,
        label: `${holeLabels[EuroCylinderHoleEu.type]} (EU)`
    },
    {
        value: EuroCylinderHoleAu.type,
        label: `${holeLabels[EuroCylinderHoleAu.type]} (AU)`
    },
    {
        value: Hole54.type,
        label: holeLabels[Hole54.type]
    },
    {
        value: OvalCylinderHole.type,
        label: holeLabels[OvalCylinderHole.type]
    },
    {
        value: PD7Hole.type,
        label: holeLabels[PD7Hole.type]
    },
    {
        value: PlainCylinderHole.type,
        label: holeLabels[PlainCylinderHole.type]
    },
    {
        value: PlainLocksetHole.type,
        label: holeLabels[PlainLocksetHole.type]
    },
    {
        value: PN6Hole.type,
        label: holeLabels[PN6Hole.type]
    },
    {
        value: RectangularHole.type,
        label: holeLabels[RectangularHole.type]
    },
    {
        value: RimCylinderHole.type,
        label: holeLabels[RimCylinderHole.type]
    },
    {
        value: SquareHole.type,
        label: holeLabels[SquareHole.type]
    }
];
const anchorPointPositionOptions = [
    {
        value: AnchorPointPosition.center,
        label: 'Center'
    },
    {
        value: AnchorPointPosition.topLeft,
        label: 'Top Left'
    },
    {
        value: AnchorPointPosition.top,
        label: 'Top'
    },
    {
        value: AnchorPointPosition.topRight,
        label: 'Top Right'
    },
    {
        value: AnchorPointPosition.right,
        label: 'Right'
    },
    {
        value: AnchorPointPosition.bottomRight,
        label: 'Bottom Right'
    },
    {
        value: AnchorPointPosition.bottom,
        label: 'Bottom'
    },
    {
        value: AnchorPointPosition.bottomLeft,
        label: 'Bottom Left'
    },
    {
        value: AnchorPointPosition.left,
        label: 'Left'
    }
];
export const featureSettingExpressions = implementAdminCustomExpressions({
    FeatureSetting: {
        $plateTypeOptions: ()=>plateTypeOptions,
        $anchorPointPositionOptions: ()=>anchorPointPositionOptions,
        $featureTypeOptions: memoEval((self)=>[
                self.plateType
            ], (plateType)=>plateType === KickPlate.type ? kickPlateFeatureTypeOptions : otherFeatureTypeOptions)
    }
});
export const featureSettingInvariants = implementCustomAdminInvariants({
    FeatureSetting: {
        noDuplicates: (self, state)=>{
            const duplicates = state.entities.filter((entity)=>entity.type === 'FeatureSetting' && entity.plateType === self.plateType && entity.featureType === self.featureType);
            if (duplicates.length > 1) {
                return [
                    {
                        type: 'noFeatureSettingDuplicatesAllowed',
                        severity: 'fatal',
                        message: 'Feature setting with the same plate type and feature type already exists!'
                    }
                ];
            }
            return [];
        }
    }
});

//# sourceMappingURL=feature-settings.js.map